import { IoAirplane } from "react-icons/io5";
import profile from "../../assets/images/Account/Icons/change-password.svg";
import AccountStatement from "../../assets/images/Account/Icons/Account-Statement.svg";
import bethistory from "../../assets/images/Account/Icons/bet-history.svg";
import logout from "../../assets/images/Account/Icons/log-out.svg";
import profitlossreport from "../../assets/images/Account/Icons/profit-loss-report.svg";
import rules from "../../assets/images/Account/Icons/rules.svg";
import setbuttonvalue from "../../assets/images/Account/Icons/set-button-value.svg";
import unsettlebet from "../../assets/images/Account/Icons/unsettle-bet.svg";
import menu1 from "../../assets/images/events/menu-1.png";
import menu2 from "../../assets/images/events/menu-2.png";
import menu4 from "../../assets/images/events/menu-4.png";
import menu7 from "../../assets/images/events/menu-7.png";
import menu4339 from "../../assets/images/events/menu-4339.png";
import menuHome from "../../assets/images/events/menu-home.png";
import menuInplay from "../../assets/images/events/menu-inplay.png";
import Multipin from "../../assets/images/events/multipin.png";



export const menuItems = [
    {
    label: "Multipin",
    livestatus: false,
    livecount: 0,
    icon: Multipin,
    link: "/multi-market",
  },
  {
    label: "Home",
    livestatus: false,
    livecount: 0,
    icon: menuHome,
    link: "/user",
  },

  {
    label: "In-Play",
    livestatus: true,
    livecount: 0,
    icon: menuInplay,
    link: "/in-play",
  },
  {
    icon: menu4,
    label: "Cricket",
    link: "/cricket",
    event: "4",
    subItems: [
      {
        label: "Brazilian Serie ASri Lanka A tour of South Africa,2024",
        link: "#",
        subItems: ["Team A vs Team B", "Team C vs Team D", "Team E vs Team F"],
      },
      {
        label: "Assam T20 Pride Cup, 2024",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "One Day Internationals",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "Test Matches",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "Caribbean Premier League`",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "Womens International Twenty20 Matches",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "CSA Provincial T20 Cup ",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "ICC Cricket World Cup League 2",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "Boland T10",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
      {
        label: "Kerala T20 Trophy",
        link: "/cricket/brazilian-serie-a",
        subItems: [
          "West Coast Blues v Stellenbosch Kings",
          "Team I vs Team J",
          "Team K vs Team L",
        ],
      },
      {
        label: "Pakistan Champions One Day Cup",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Team G vs Team H", "Team I vs Team J", "Team K vs Team L"],
      },
    ],
  },
  {
    icon: menu1,
    label: "Soccer",
    event: "1",
    link: "#",
    subItems: [
      {
        label: "Brazilian Serie A",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Internacional v Cuiaba"],
      },
      {
        label: "Danish Superliga",
        link: "/cricket/brazilian-serie-a",
        subItems: ["FC Nordsjaelland v Randers"],
      },
      {
        label: "English League 1",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Birmingham v Wrexham"],
      },
      {
        label: "French Ligue 2",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Grenoble v Caen"],
      },
      {
        label: "Italian Serie A",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Parma v Udinese", "Lazio v Verona"],
      },
      {
        label: "Portuguese Primeira Liga",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Club Football Estrela v Boavista"],
      },
      {
        label: "Spanish La Liga",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Rayo Vallecano v Osasuna", "Mallorca v Real Sociedad"],
      },
      {
        label: "Swedish Allsvenskan",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Hammarby v Norrkoping"],
      },
      {
        label: "Romanian Liga I",
        link: "/cricket/brazilian-serie-a",
        subItems: [
          "UTA Arad v Hermannstadt",
          "Rapid Bucharest v Universitatea Cluj",
        ],
      },
      {
        label: "Turkish Super League",
        link: "/cricket/brazilian-serie-a",
        subItems: [
          "Antalyaspor v Adana Demirspor",
          "Galatasaray v Gaziantep FK",
        ],
      },
      {
        label: "Irish Premier Division",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Galway Utd v Shamrock Rovers"],
      },
      {
        label: "Spanish Segunda Division",
        link: "/cricket/brazilian-serie-a",
        subItems: ["Almeria v CD Castellon"],
      },
    ],
  },
  {
    icon: menu2,
    label: "Tennis",
    link: "#",
    event: "2",
    subItems: [
      {
        label: "WTA Seoul 2024",
        link: "/cricket/brazilian-serie-a",
        subItems: [
          "A Rus v M Kostyuk",
          "Da Back v C Zhao",
          "E Ruse v Y Yuan",
          "Watson v Jia-Jin Lu",
          "Alexandrova v Lepchenko",
        ],
      },
      {
        label: "WTA Hua Hin II 2024",
        link: "/cricket/brazilian-serie-a",
        subItems: [
          "Aly Parks v Siegemund",
          "La Tararudee v Naklo",
          "Ar Rodionova v K Siniakova",
          "Volynets v C Tauson",
          "V Gracheva v Tay Preston",
          "Golubic v X Wang",
          "T Zidansek v Tat Prozorova",
        ],
      },
    ],
  },
  {
    icon: menu7,
    label: "Horse",
    link: "/horse",
    // subItems: [
    //   {
    //     label: "AU-Corowa",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Corowa (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "IE-Laytown",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Laytown 16th Sep"],
    //   },
    //   {
    //     label: "GB-Windsor",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Windsor 16th Sep"],
    //   },
    //   {
    //     label: "US-Philadelphia",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Philadelphia (US) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Gawler",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Gawler (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Hamilton",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Hamilton (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Tamworth",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Tamworth (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "GB-Worcester",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Worcester 16th Sep"],
    //   },
    //   {
    //     label: "GB-Kempton",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Kempton 16th Sep"],
    //   },
    //   {
    //     label: "GB-Thirsk",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Thirsk 16th Sep"],
    //   },
    //   {
    //     label: "AU-Goulburn",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Goulburn (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Pinjarra",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Pinjarra (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "FR-Chantilly",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Chantilly (FRA) 16th Sep"],
    //   },
    //   {
    //     label: "FR-Marseille-borely",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Marseille-borely (FRA) 16th Sep"],
    //   },
    //   {
    //     label: "US-Finger Lakes",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Finger Lakes (US) 16th Sep"],
    //   },
    // ],
  },
  {
    icon: menu4339,
    label: "Greyhound",
    link: "/greyhound",
    // subItems: [
    //   {
    //     label: "AU-Sandown Park",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Sandown Park (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Angle Park",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Angle Park (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Albion Park",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Albion Park (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Warrnambool",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Warrnambool (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Wagga",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Wagga (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Nowra",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Nowra (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Maitland",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Maitland (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Launceston",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Launceston (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "NZ-Addington",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Addington (NZL) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Bundaberg",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Bundaberg (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "AU-Shepparton",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Shepparton (AUS) 16th Sep"],
    //   },
    //   {
    //     label: "GB-Romford",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Romford 16th Sep"],
    //   },
    //   {
    //     label: "GB-Harlow",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Harlow 16th Sep"],
    //   },
    //   {
    //     label: "GB-Swindon",
    //     link: "/cricket/brazilian-serie-a",
    //     subItems: ["Swindon 16th Sep"],
    //   },
    // ],
  },
  {
    label: "Spribe",
    link: "/spribe",
    livestatus: false,
    livecount: 0,
    icon: IoAirplane,
  },
];

// export const navItems = [
//   { name: "Home", livestatus: false, livecount: 0, href: "/" },
//   { name: "In-Play", livestatus: false, livecount: 0, href: "/in-play" },
//   { name: "US Election", livestatus: true, livecount: 4, href: "/" },
//   { name: "Cricket", livestatus: true, livecount: 8, href: "/cricket" },
//   { name: "Soccer", livestatus: true, livecount: 5, href: "/soccer" },
//   { name: "Tennis", livestatus: true, livecount: 2, href: "/tennis" },
//   { name: "Horse", livestatus: true, livecount: 3, href: "/" },
//   { name: "Greyhound", livestatus: true, livecount: 6, href: "/" },
//   { name: "Indian Poker", livestatus: false, livecount: 0, href: "/" },
//   { name: "Indian Poker II", livestatus: false, livecount: 0, href: "/" },
//   { name: "Aviator", livestatus: true, livecount: 0, href: "/" },
//   { name: "AE SEXY", livestatus: false, livecount: 0, href: "/" },
//   { name: "Evolution", livestatus: false, livecount: 0, href: "/" },
//   { name: "Live Casino", livestatus: false, livecount: 0, href: "/" },
//   { name: "Vivo", livestatus: false, livecount: 0, href: "/" },
//   { name: "Betgames", livestatus: false, livecount: 0, href: "/" },
//   { name: "Casino III", livestatus: false, livecount: 0, href: "/" },
// ];
export const navItems = [
  {
    isDisabled: false,
    name: "Home",
    livestatus: false,
    livecount: 0,
    href: "/",
  },
  {
    isDisabled: false,
    name: "In-Play",
    livestatus: false,
    livecount: 0,
    href: "/in-play",
  },

  {
    isDisabled: false,
    name: "Cricket",
    livestatus: true,
    livecount: 8,
    href: "/cricket",
  },
  {
    isDisabled: false,
    name: "Soccer",
    livestatus: true,
    livecount: 5,
    href: "/soccer",
  },
  {
    isDisabled: false,
    name: "Tennis",
    livestatus: true,
    livecount: 2,
    href: "/tennis",
  },
  {
    isDisabled: true,
    name: "Spribe",
    livestatus: false,
    livecount: 3,
    href: "/spribe",
  },
  // {
  //   isDisabled: true,
  //   name: "Aviator",
  //   livestatus: false,
  //   livecount: 3,
  //   href: "",
  // },
  {
    isDisabled: true,
    name: "Horse",
    livestatus: true,
    livecount: 0,
    href: "/horse",
  },
  {
    isDisabled: true,
    name: "Greyhound",
    livestatus: true,
    livecount: 0,
    href: "/greyhound",
  },
  {
    isDisabled: true,
    name: "Ezugi",
    livestatus: false,
    livecount: 3,
    href: "/ezugi",
  },
  {
    isDisabled: true,
    name: "Evolution",
    livestatus: false,
    livecount: 3,
    href: "/evolution",
  },
  {
    isDisabled: true,
    name: "Live Casino",
    livestatus: false,
    livecount: 0,
    href: "/live-casino",
  },
  {
    isDisabled: true,
    name: "Ae Sexy",
    livestatus: false,
    livecount: 3,
    href: "/ae-sexy",
  },
  {
    isDisabled: true,
    name: "Vivo",
    livestatus: false,
    livecount: 3,
    href: "/vivo",
  },

  // {
  //   isDisabled: true,
  //   name: "Kabaddi",
  //   livestatus: false,
  //   livecount: 3,
  //   href: "/kabaddi",
  // },

  // {
  //   isDisabled: true,
  //   name: "Election",
  //   livestatus: false,
  //   livecount: 4,
  //   href: "/election",
  // },
  // {
  //   isDisabled: true,
  //   name: "Indian Poker",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/indian-poker",
  // },
  // {
  //   isDisabled: true,
  //   name: "Indian Poker II",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/indian-poker-ii",
  // },
  // {
  //   isDisabled: true,
  //   name: "Aviator",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/aviator",
  // },
  // {
  //   isDisabled: true,
  //   name: "AE SEXY",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/ae-sexy",
  // },
  // {
  //   isDisabled: true,
  //   name: "Evolution",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/evolution",
  // },

  // {
  //   isDisabled: true,
  //   name: "Vivo",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/vivo",
  // },
  // {
  //   isDisabled: true,
  //   name: "Betgames",
  //   livestatus: false,
  //   livecount: 0,
  //   href: "/betgames",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Casino III",
  //   livecount: 0,
  //   href: "/casino-iii",
  // },
];

export const navItemsMobile = [
  {
    isDisabled: false,
    livestatus: true,
    livecount: 0,
    name: "In-Play",
    icon: "/sports-icons.png",
    href: "/in-play",
    left: "-1527px",
  },

  {
    isDisabled: false,
    livestatus: true,
    name: "Cricket",
    icon: "/sports-icons.png",
    href: "/cricket",
    left: "-326px",
  },
  {
    isDisabled: false,
    livestatus: true,
    name: "Soccer",
    icon: "/sports-icons.png",
    href: "/soccer",
    left: "-1026px",
  },
  {
    isDisabled: false,
    livestatus: true,
    name: "Tennis",
    icon: "/sports-icons.png",
    href: "/tennis",
    left: "-1096px",
  },
  {
    isDisabled: true,
    name: "Spribe",
    livestatus: true,
    livecount: 9,
    href: "/spribe",
  },
  // {
  //   isDisabled: true,
  //   name: "Aviator",
  //   livestatus: false,
  //   livecount: 3,
  //   href: "",
  // },
  {
    isDisabled: true,
    livestatus: true,
    name: "Horse",
    icon: "/sports-icons.png",
    href: "/horse",
    left: "-677px",
  },
  {
    isDisabled: true,
    livestatus: true,
    name: "Greyhound",
    icon: "/sports-icons.png",
    href: "/greyhound",
    left: "-630px",
  },
  {
    isDisabled: true,
    livestatus: false,
    livecount: 0,
    name: "Live Casino",
    icon: "/sports-icons.png",
    href: "/live-casino",
    left: "-863px",
  },
  {
    isDisabled: true,
    name: "Ezugi",
    livestatus: false,
    livecount: 3,
    href: "/ezugi",
    icon: "/sports-icons.png",
    left: "-1707px",
  },
  {
    isDisabled: true,
    name: "Evolution",
    livestatus: false,
    livecount: 3,
    href: "/evolution",
    icon: "/sports-icons.png",
    left: "-1707px",
  },

  {
    isDisabled: true,
    name: "Ae Sexy",
    livestatus: false,
    livecount: 3,
    href: "/ae-sexy",
    icon: "/sports-icons.png",
    left: "-863px",
  },
  {
    isDisabled: true,
    name: "Vivo",
    livestatus: false,
    livecount: 21,
    href: "/vivo",
    // icon: "/sports-icons.png",
    // left: "-1707px",
  },
  // {
  //   isDisabled: true,
  //   name: "Kabaddi",
  //   livestatus: true,
  //   livecount: 3,
  //   href: "/kabaddi",
  //   left: "-1707px",
  // },

  // {
  //   isDisabled: true,
  //   livestatus: true,
  //   name: "Election",
  //   href: "/election",
  //   icon: "/sports-icons.png",
  //   left: "-1707px",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Indian Poker",
  //   icon: menu99998,
  //   href: "/indian-poker",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Indian Poker II",
  //   icon: menu99998,
  //   href: "/indian-poker-ii",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Aviator",
  //   icon: IoAirplane,
  //   href: "/aviator",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "AE SEXY",
  //   icon: GiPokerHand,
  //   href: "/aesexy",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Evolution",
  //   icon: menu29,
  //   href: "/evolution",
  // },

  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Vivo",
  //   icon: menu998917,
  //   href: "/vivo",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Betgames",
  //   icon: menu99991,
  //   href: "/betgames",
  // },
  // {
  //   isDisabled: true,
  //   livestatus: false,
  //   name: "Casino III",
  //   icon: menu99999,
  //   href: "/casino-iii",
  // },
];

export const AccountSidebar = [
  { label: "Profile", href: "/profile", icon: profile },
  
  {
    label: "Profit Loss Report",
    href: "/profit-loss-report",
    icon: profitlossreport,
  },
  {
    label: "Account Statement",
    href: "/account-statement",
    icon: AccountStatement,
  },
  { label: "Bonus Rules", href: "#", icon: rules },

  { label: "Live Bets", href: "/unsettled-bet", icon: unsettlebet },
  { label: "Bet History", href: "/bet-history", icon: bethistory },
  { label: "Stake Settings", href: "/set-stake", icon: setbuttonvalue },
  { label: "Change Password", href: "/change-password", icon: profile },
  { label: "Logout", href: "/", icon: logout },
];
